import { getLocalStorageItem, removeLocalStorageItem } from "@/utils/common";

export const getCurrentPlatformId = () => {
  const platformId = getLocalStorageItem<number | null>("platformId");
  return platformId;
};

export const clearCurrentPlatformId = () => {
  removeLocalStorageItem("platformId");
};
